import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p className="header-text">Think80</p>
        <p className="subHeaderText">thoughtful designs</p>  
      </header>
    </div>
  );
}

export default App;
